import HttpRequest from '@libs/axios'

const axios = new HttpRequest()
export default axios